export default __webpack_public_path__ + "static/media/money-back@2x.b02e9eb5.png";